(function(){
	console.log("About APP")
    if(typeof APPS === 'undefined'){ APPS = {}; }
    APPS.about = {};
    
    /*================================================================================
		Router
	 ================================================================================*/
    var Router = Marionette.AppRouter.extend({
        appRoutes:{
             "about":"about"
        }
    })
    
    /*================================================================================
		Api - called by the Router 
	 ================================================================================*/
    var API = {
        about:function(){
	        APPS.about.page.show();
        },
    }
    
    APP.on("before:start",function(){
		new Router({
			controller: API
		})
	})
})();
